export default "__VITE_ASSET__sqUPP02E__"